import config from '../../../assets/js/conf/config';
import md5 from 'js-md5';
import { getGoodsData, getGoodsSearchData, getDetailsData, setCollectionData } from "../../../api/goods";

export default {
  namespaced: true,
  state: {
    goodList: [],
    details: {
      entity: [],
      experience: [],
      image_url:[],
    },

  },
  mutations: {

    ["SET_GOODS"](state, payload) {
      // 获取值并提交到state VUEX缓存中
      state.goodList = payload.good;
    },
    // 设置商品详情
    ["SET_DETAILS"](state, payload) {
      state.details = payload.details;
    },

    // 设置收藏
    ["SET_COLLECTION"](state, payload) {

      state.details.is_collection = payload.type;
      if (payload.type === 1) {
        state.details.collection_num = parseInt(state.details.collection_num) + 1;
      } else {
        state.details.collection_num = parseInt(state.details.collection_num) - 1;
      }

    },



  },
  actions: {

    //产品列表
    getGoods(conText, payload) {

      // console.log(res)
      let productKey = config.productKey;
      let time = new Date().getTime().toString();
      // console.log(productKey)
      // console.log(time)

      let token = md5(md5(time) + '|' + productKey);
      let data = {
        time,
        token
      }
      getGoodsData(JSON.stringify(data)).then(res => {
        // console.log(res)

        if (res.status == 1) {
          conText.commit("SET_GOODS", { good: res.data });
        }
        if (payload.success) {
          payload.success(res);
        }
      })

    },

    //搜索产品列表
    getGoodsSearch(conText, payload) {

      // console.log(res)
      let productKey = config.productKey;
      // let time = new Date().getTime().toString();
      // console.log(productKey)
      // console.log(time)

      let title = payload.title;
      let searchSort = payload.searchSort;
      let token = md5(md5(title + '|' + searchSort) + '|' + productKey);
      let data = {
        title,
        searchSort,
        token
      }
      getGoodsSearchData(JSON.stringify(data)).then(res => {
        // console.log(res)
        if (res.status == 1) {
          conText.commit("SET_GOODS", { good: res.data });
        } else {
          conText.commit("SET_GOODS", { good: [] });
        }
        if (payload.success) {
          payload.success(res);

        }
      })

    },





    //产品详情
    getDetails(conText, payload) {

      // console.log(res)
      let productKey = config.productKey;
      let time = new Date().getTime().toString();
      let id = payload.id;

      let security = conText.rootState.user.security;
      let guid = conText.rootState.user.guid;

      // console.log(security);
      // console.log(guid);

      let token = md5(md5(time + '|' + id) + '|' + productKey);
      let data = {
        security,
        guid,
        time,
        token,
        id
      }
      getDetailsData(JSON.stringify(data)).then(res => {
        // console.log(res)
        if (res.status == 1) {
          conText.commit("SET_DETAILS", { details: res.data });
        }
        if (payload.success) {
          payload.success(res);
        }
      })

    },

    //设置收藏
    setCollection(conText, payload) {

      // console.log(res)
      let productKey = config.productKey;
      let time = new Date().getTime().toString();
      let id = payload.id;

      let security = conText.rootState.user.security;
      let guid = conText.rootState.user.guid;

      let type = payload.type;  // 1收藏  0取消收藏

      // console.log(security);
      // console.log(guid);

      // let token =  md5(md5(time+'|'+id)+'|'+productKey);

      let token = md5(md5(guid + '|' + security + '|' + id + '|' + type) + '|' + productKey);

      let data = {
        security,
        guid,
        token,
        type,
        id
      }
      setCollectionData(JSON.stringify(data)).then(res => {
        // console.log(res)
        if (res.status == 1) {
          conText.commit("SET_COLLECTION", { type: type });
        }
        if (payload.success) {
          payload.success(res);
        }
      })

    },



  }
}